export const defaultContactMethod = 3
export const defaultPhonePrefix = 1
export const defaultSex = 4
